import React from "react";
import GenericRoutesMap from "components/Routes/GenericRoutesMap";
import { ROUTE_CONFIGS } from "config/routeConfigs";

const RecentsMap = () => {
  const config = ROUTE_CONFIGS.recent;
  return (
    <GenericRoutesMap
      routeType="recent"
      selector={config.selector}
      loadAction={config.loadAction}
      features={config.features}
    />
  );
};

export default RecentsMap;